if (!customElements.get('pivot-mix-bundle')) {
  customElements.define('pivot-mix-bundle', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.form = this.closest('form') || document.getElementById(this.dataset.formId);
      if (!this.form) return;
      this.initialized = true;
      this.inputs = [...this.querySelectorAll('[data-variant]')];
      this.button = this.form.querySelector('[name="add"]');
      this.total = Number(this.dataset.total);
      this.french = this.dataset.locale === 'fr';
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-step]');
        if (!button || button.disabled) return;
        const input = button.parentElement.querySelector('input');
        input.value = String(Number(input.value) + Number(button.dataset.step));
        this.update();
      });
      this.form.addEventListener('input', event => this.update(event.target));
      this.form.addEventListener('change', event => this.update(event.target));
      this.form.addEventListener('submit', event => {
        if (!this.update()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.querySelector('[data-message]').focus();
        }
      }, true);
      this.querySelector('[data-message]').tabIndex = -1;
      this.update();
    }

    update(changedInput) {
      const caseCount = Number(this.form.querySelector('[name="quantity"]')?.value || 1);
      // Clamp typed values too, including paste, decimals and negative values.
      if (this.inputs.includes(changedInput)) {
        const others = this.inputs.filter(input => input !== changedInput)
          .reduce((sum, input) => sum + Math.max(0, Number(input.value) || 0), 0);
        const value = Number(changedInput.value);
        changedInput.value = String(Number.isFinite(value) ? Math.max(0, Math.min(value, this.total - others)) : 0);
      }
      let available = this.total;
      this.inputs.forEach(input => {
        const stock = Number(input.dataset.stock);
        const maximum = Number.isSafeInteger(caseCount) && caseCount > 0
          ? Math.max(0, Math.min(available, Math.floor(stock / caseCount))) : 0;
        const value = Number(input.value);
        const quantity = Number.isFinite(value) ? Math.max(0, Math.min(maximum, Math.floor(value))) : 0;
        input.value = String(quantity);
        available -= quantity;
      });
      const quantities = this.inputs.map(input => Number(input.value));
      const count = quantities.reduce((sum, quantity) => sum + quantity, 0);
      let valid = Number.isSafeInteger(caseCount) && caseCount > 0 && this.total === 12 && count === this.total && this.inputs.length > 0;
      const selection = [];
      const summary = [];
      this.inputs.forEach((input, index) => {
        const quantity = quantities[index];
        const stock = Number(input.dataset.stock);
        const maximum = Math.min(this.total, Math.floor(stock / caseCount));
        const remaining = Math.max(0, this.total - count + quantity);
        input.max = String(Math.min(maximum, remaining));
        if (!Number.isSafeInteger(quantity) || quantity < 0 || quantity > maximum) valid = false;
        const buttons = input.parentElement.querySelectorAll('[data-step]');
        buttons[0].disabled = input.disabled || quantity <= 0;
        buttons[1].disabled = input.disabled || quantity >= maximum || count >= this.total;
        if (quantity > 0) {
          selection.push({id: input.dataset.variant, quantity});
          const label = this.querySelector(`label[for="${input.id}"]`);
          summary.push(`${quantity} × ${label.textContent.trim()}`);
        }
      });
      this.querySelector('[data-progress]').textContent = `${Number.isFinite(count) ? count : 0} / ${this.total}`;
      this.querySelector('[data-message]').textContent = valid
        ? (this.french ? 'Votre caisse est prête.' : 'Your case is ready.')
        : (this.french ? 'Choisissez exactement 12 canettes parmi les saveurs disponibles.' : 'Choose exactly 12 cans from the available flavours.');
      this.querySelector('[name="properties[_pivot_mix_bundle_selection]"]').value = valid ? JSON.stringify(selection) : '[]';
      this.querySelector('[data-summary]').value = valid ? summary.join(', ') : '';
      if (this.button && this.button.getAttribute('aria-disabled') !== 'true') this.button.disabled = !valid;
      return valid;
    }
  });
}